import _ from "lodash";

//获取对象
export function getItem(key) {
  if (!_.isString(key)) {
    return;
  }
  if (_.isEmpty(key)) {
    return;
  }
  let item = localStorage.getItem(key);
  if (_.isEmpty(item)) {
    return;
  }
  return JSON.parse(item);
}

//保存对象
export function setItem(key, value) {
  if (_.isEmpty(key)) {
    return;
  }
  let json = JSON.stringify(value);
  localStorage.setItem(key, json);
}
